import { render, staticRenderFns } from "./review-list-element.vue?vue&type=template&id=d2d2956c&scoped=true"
import script from "./review-list-element.vue?vue&type=script&lang=js"
export * from "./review-list-element.vue?vue&type=script&lang=js"
import style0 from "./review-list-element.vue?vue&type=style&index=0&id=d2d2956c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d2956c",
  null
  
)

export default component.exports